import React from "react";

export default function PanVerification() {
  return (
    <div>
      <p>PanVerification</p>
    </div>
  );
}
